import type { SubscriptionType } from '@ori-events/subscription-types';

type EventName = 'subscription-error';

export const eventName: EventName = 'subscription-error';

export const subscriptionError: EventName = eventName;

export interface EventData {
  type: SubscriptionType;
  productCode?: string;
  error?: {
    code: number;
    message: string;
  };
}

export interface Event extends CustomEvent<EventData> {
  type: EventName;
}

declare global {
  interface WindowEventMap {
    'subscription-error': CustomEvent<EventData>;
  }
}

/**
 * Dispatch event when subscription is saved
 *
 * @param {CustomEventInit<EventData>} data data which will be passed to event
 * @fires globalThis#subscription-error:subscription-error
 */
export function dispatch(data: CustomEventInit<EventData>) {
  const event = new CustomEvent<EventData>(eventName, data);
  globalThis.dispatchEvent(event);
}

/**
 * Listen callback for our event
 *
 * @callback listenCallback
 * @param {CustomEvent<EventData>} event - Event data
 * @returns {void}
 */

/**
 * Helper function which wraps event so we never miss.
 * @param {listenCallback} callback - That handles response
 * @param {(boolean | AddEventListenerOptions)} [options] - options of event
 */
export function listen(callback: (event: CustomEvent<EventData>) => void, options?: AddEventListenerOptions | boolean) {
  globalThis.addEventListener<EventName>(eventName, callback, options);
}

/**
 * Clean event when you don't need to listen anymore.
 * @param {listenCallback} callback - that should be cleaned.
 */
export function clean(callback: (event: CustomEvent<EventData>) => void) {
  globalThis.removeEventListener(eventName, callback);
}

export default {
  dispatch,
  listen,
  clean,
  eventName,
  subscriptionError,
};
